
import getProp from '@f/get-prop'

export function getLockouts (state) {
  return state.lockouts.data
}

export function getLockoutByWorkspaceSlug (state, slug) {
  return getProp(`lockouts.data.${slug}.data`, state)
}

export function getLockoutRequestByWorkspaceSlug (state, slug) {
  const lockout = getProp(`lockouts.data.${slug}`, state)

  if (!lockout) {
    return {}
  }

  return {
    isRequesting: lockout.isRequesting,
    didRequestFail: lockout.isRequesting
  }
}

export function hasLockoutRequested (state, workspaceSlug) {
  const {
    isRequesting
  } = getLockoutRequestByWorkspaceSlug(state, workspaceSlug)

  return !isRequesting
}

export function shouldLockoutRedirect (state, workspaceSlug, location) {
  const lockout = getLockoutByWorkspaceSlug(state, workspaceSlug)

  // If not on post-redirect page (settings), block app rendering
  // to prevent poor UX banner/modal flashing while redirect happens
  const redirectPath = `/${workspaceSlug}/settings`
  const shouldLockoutRedirect = location.pathname !== redirectPath

  // If there's no lockout, then don't redirect
  if (!lockout) {
    return false
  }

  return shouldLockoutRedirect
}

export function getLockoutsRequest (state) {
  return {
    isRequesting: state.lockouts.isRequesting,
    didRequestFail: state.lockouts.didRequestFail
  }
}

export function getLockoutsApp (state) {
  return state.application.lockouts
}



// WEBPACK FOOTER //
// ./selectors/lockouts.js